module.exports = __webpack_public_path__ + "cbd3537012aa57bfd46d9f63a72de764.svg";